import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  Company,
  getTokensLocalStorage,
  Tokens,
  User,
} from '../../../services';

import useAuthStore from '../../../store/auth';
import useUserStore from '../../../store/users';
import useCompanyStore from '../../../store/companies';
import { createLogForLogin } from '../utils/create-logs';
import { AuthSectionSteps } from '../types/AuthSectionSteps';

export const useAuth = () => {
  const navigate = useNavigate();

  const { setSelectedUserInCompany } = useUserStore(state => state);
  const { setSelectedCompany, setCompanies } = useCompanyStore(state => state);
  const {
    user: userAuth,
    setUserAuthenticated,
    setMenuSelected,
  } = useAuthStore(state => state);

  const tokensLocalStorage = getTokensLocalStorage() as Tokens;

  const handleRedirect = useCallback(
    async (
      user: User,
      companiesList: Company[],
      setIsLoading: (loading: boolean) => void,
      setStepLogin: (step: AuthSectionSteps) => void,
    ) => {
      if (user) {
        const userIsTenUser = user?.profile === 'UN1';
        // console.log(userIsTenUser);

        if (userIsTenUser) {
          // console.log('LISTAGEM EMPRESAS MASTER', listagemEmpresasMaster);
          setSelectedCompany(companiesList[0]);
          setMenuSelected('account');
          createLogForLogin(
            user,
            companiesList[0]?.id as string,
            companiesList[0]?.name as string,
          );

          setUserAuthenticated(user, tokensLocalStorage);
          return navigate('/home/contas');
        }

        const commonCompaniesListIsEqualToOne = companiesList?.length === 1;
        const commonCompaniesListIsMoreThanOne = companiesList?.length > 1;

        // console.log('NÃO É MASTER');

        if (!userIsTenUser && commonCompaniesListIsEqualToOne) {
          // console.log('TEM UMA EMPRESA');

          const firstCompanyOfList = companiesList[0];

          const userInCompanyExists = firstCompanyOfList?.users?.find(
            u => u.doc === user?.doc,
          );

          if (userInCompanyExists) {
            const userInCompany = {
              ...user,
              profile: userInCompanyExists?.profile,
            };

            setUserAuthenticated(user, tokensLocalStorage);
            setSelectedUserInCompany(userInCompany);
          } else {
            setSelectedUserInCompany(user);
            setUserAuthenticated(user, tokensLocalStorage);
          }

          setMenuSelected('portal');
          setSelectedCompany(firstCompanyOfList);
          createLogForLogin(
            user,
            firstCompanyOfList?.id as string,
            firstCompanyOfList?.name as string,
          );
          return navigate('/home/reunioes');
        }

        if (!userIsTenUser && commonCompaniesListIsMoreThanOne) {
          // console.log('TEM VÁRIAS EMPRESAS');

          setIsLoading(false);
          return setStepLogin(AuthSectionSteps.SELECT_COMPANY);
        }
        // console.log('NÃO TEM VÁRIAS');

        setIsLoading(false);
        return setStepLogin(AuthSectionSteps.NO_LINKED_COMPANIES);
      }

      setIsLoading(false);
      return setStepLogin(AuthSectionSteps.UNAUTHORIZED);
      // console.log(user, 'NÃO TEM STATE');
    },
    [
      navigate,
      setMenuSelected,
      setSelectedCompany,
      setSelectedUserInCompany,
      setUserAuthenticated,
      tokensLocalStorage,
    ],
  );

  return { handleRedirect };
};
